<ng-container *ngIf="dialogClass">
  <div class="a3l-ui-helper-wrapper" [ngClass]="iconClass"><span (click)="openDialog($event)" [ngClass]="{ 'ml-2': !absolute, 'a3l-ui-icon-absolute': absolute}" class="a3l-ui-icon a3l-ui-icon-info" a3l-ui-helper></span></div>
</ng-container>
<ng-container *ngIf="tooltipInfo">
  <div class="a3l-ui-helper-wrapper" [ngClass]="iconClass"><span [a3l-ui-tooltip]="tooltipInfo" [ngClass]="{ 'ml-2': !absolute, 'a3l-ui-icon-absolute': absolute}" class="a3l-ui-icon a3l-ui-icon-info"></span></div>
</ng-container>
